var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"set-time"},[_c('p',{staticClass:"time"},[_vm._v(_vm._s(_vm.time))]),_c('p',{staticClass:"artist"},[_vm._v(_vm._s(_vm.artist))])])}
var staticRenderFns = []

export { render, staticRenderFns }